import { render } from "./Trash.vue?vue&type=template&id=6abca1cc"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Trash.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6abca1cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6abca1cc', __exports__)) {
    api.reload('6abca1cc', __exports__)
  }
  
  module.hot.accept("./Trash.vue?vue&type=template&id=6abca1cc", () => {
    api.rerender('6abca1cc', render)
  })

}


export default __exports__